var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 13.3334L15.0013 13.3334C15.4433 13.3334 15.8673 13.1578 16.1798 12.8452C16.4924 12.5327 16.668 12.1087 16.668 11.6667L16.668 5.00004C16.668 4.55801 16.4924 4.13409 16.1798 3.82153C15.8673 3.50897 15.4433 3.33337 15.0013 3.33337L8.33464 3.33337C7.89261 3.33337 7.46869 3.50897 7.15612 3.82153C6.84356 4.13409 6.66797 4.55801 6.66797 5.00004L6.66797 6.66671M11.668 6.66671C12.11 6.66671 12.5339 6.8423 12.8465 7.15486C13.159 7.46742 13.3346 7.89135 13.3346 8.33337L13.3346 15C13.3346 15.4421 13.159 15.866 12.8465 16.1786C12.5339 16.4911 12.11 16.6667 11.668 16.6667L5.0013 16.6667C4.55927 16.6667 4.13535 16.4911 3.82279 16.1786C3.51023 15.866 3.33464 15.4421 3.33464 15L3.33464 8.33337C3.33464 7.89135 3.51023 7.46742 3.82279 7.15486C4.13535 6.8423 4.55927 6.66671 5.0013 6.66671L11.668 6.66671Z",
    stroke: "#00FFE0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/copyDark.9c1f15c687a6c4bc9d32765fd3c381d9.svg";
export { ForwardRef as ReactComponent };